import { render } from "./PaperPlane.vue?vue&type=template&id=e2337a70&scoped=true&ts=true"
import script from "./PaperPlane.vue?vue&type=script&lang=ts"
export * from "./PaperPlane.vue?vue&type=script&lang=ts"

import _style_0 from "./PaperPlane.vue?vue&type=style&index=0&id=e2337a70&inline&scoped=true&lang=scss"

import exportComponent from "/Users/philippniestroj/Desktop/AgenturPhilipp/ProductFinder/Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['styles',[_style_0]],['__scopeId',"data-v-e2337a70"]])

export default __exports__